export const APP_PATHS = {
  AUTH: 'auth',
  LOGIN: 'log-in',
  SIGNUP: 'sign-up',
  RESET_PASSWORD: 'reset-password',
} as const;

export const APP_FULL_PATHS = {
  BASE: '/',
  AUTH: '/auth',
  LOGIN: '/auth/log-in',
  SIGNUP: '/auth/sign-up',
  DASHBOARD: '/dashboard',
  RESET_PASSWORD: '/auth/reset-password',
} as const;
